export const STORAGE_NAVIGATION_SIDEBAR_OPENED_KEY = 'navSidebarOpened';

/** Root of the dashboard feature, including its tabs and the instrument details nested under them. */
export const DASHBOARD_ROUTE_PATH = '/dashboard';

export { HEADER_NAVIGATION_MENU_ITEMS } from './header-navigation-menu-items';
